export enum CandidateApplicationStatus {
  IN_PROCESSING = 'IN_PROCESSING',
  PROCESSED = 'PROCESSED',
}
